/**
 * Query key factory for Reviews module
 * Provides centralized query key management for React Query
 */

export const reviewKeys = {
  all: ['reviews'] as const,

  // Review list keys
  list: (sku: string, pageSize?: number, currentPage?: number) =>
    [...reviewKeys.all, 'list', sku, { pageSize, currentPage }] as const,

  // Rating metadata keys
  ratings: () => [...reviewKeys.all, 'ratings'] as const,
}
